import { Component, OnInit, ViewEncapsulation, ElementRef, Input, ViewChild, TemplateRef} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators, ReactiveFormsModule} from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppSettings } from '../../../app.settings';
import  *  as  helpData  from  '../../../data/help/notifications_settings.json';
import { LocalStorage } from 'ngx-store';

//Model
import { Settings } from '../../../app.settings.model';
import { User } from '../../../model/users.model';

//Service
import { DataService } from '../../../services/data.service';
import { NotificationsSettingsService } from '../../../services/notificationssettings.service';
import { NotificationService } from '../../../services/notification.service';

@Component({
  selector: 'app-notificationssettings',
  templateUrl: './notificationssettings.component.html',
  styleUrls: ['./notificationssettings.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [NotificationsSettingsService]
})

export class NotificationsSettingsComponent implements OnInit {
	@Input() caller : string;
	@Input() customer_id : number;
	@LocalStorage() user: User;
	@ViewChild('modalAttachment', { static: false }) modalAttachment: TemplateRef<any>;
	
	check_all_docs_email: boolean = true;
	check_all_docs_sms: boolean = true;
	check_all_notifs_email: boolean = true;
	check_all_notifs_sms: boolean = true;

	disable_all_docs_email: boolean = false;
	disable_all_docs_sms: boolean = false;
	disable_all_notifs_email: boolean = false;
	disable_all_notifs_sms: boolean = false;

	loadingIndicator: boolean = true;
	spinner: boolean = false;
    help: any;
	customer_settings = [];
	global_settings = [];
	customer_attachments = [];
	global_attachments = [];
	public frm_notifications :FormGroup;
	frm_touched :boolean = false;

	constructor(private fb : FormBuilder,
				public router: Router,
				private data: DataService,
				private svc_notifications: NotificationsSettingsService,
				private toastr: NotificationService,
				private modal: NgbModal
    	) { 

    }

	ngOnInit(){
		console.log(this.caller);
		this.spinner = false;
		this.data.currentHelp.subscribe(help => this.help = help);
		this.loadingIndicator = true;
		
		if(this.caller == "Global"){
			this.svc_notifications.getGlobalNotificationSetting().subscribe(data=>{
				this.global_settings = data['global_notif_settings'];
				this.global_attachments = data['global_attachments'];
				this.initializeForm(0);

				var addCtrl = <FormArray> this.frm_notifications.controls.notifications;
				addCtrl.removeAt(0);
				this.global_settings.forEach(item =>{
					let i = 0;
					addCtrl.push(this.setNotification(0,item));
					i=+1;
				})

				var addCtrl = <FormArray> this.frm_notifications.controls.attachments;
				addCtrl.removeAt(0);
				this.global_attachments.forEach(item =>{
					let i = 0;
					addCtrl.push(this.setAttachment(0,item));
					i=+1;
				});

				setTimeout(() => { 
					this.loadingIndicator = false; 
					
					this.check_all_docs_email = true;
					this.check_all_docs_sms = true;
					this.check_all_notifs_email = true;
					this.check_all_notifs_sms = true;

					this.checkSetAllCheckboxValue();
				}, 1000);

			});

		}else if(this.caller == "Customer"){
			this.svc_notifications.getCustomerNotificationSetting(this.customer_id).subscribe(data=>{
				this.customer_settings = data['customer_notif_settings'];
				this.customer_attachments = data['customer_attachments'];
				this.initializeForm(this.customer_id);
				
				var addCtrl = <FormArray> this.frm_notifications.controls.notifications;
				addCtrl.removeAt(0);
				this.customer_settings.forEach(item =>{
					let i = 0;
					addCtrl.push(this.setNotification(this.customer_id,item));
					i=+1;
				})

				var addCtrl = <FormArray> this.frm_notifications.controls.attachments;
				addCtrl.removeAt(0);
				this.customer_attachments.forEach(item =>{
					let i = 0;
					addCtrl.push(this.setAttachment(this.customer_id,item));
					i=+1;
				})
				
				setTimeout(() => { 
					this.loadingIndicator = false;
					this.check_all_docs_email = true;
					this.check_all_docs_sms = true;
					this.check_all_notifs_email = true;
					this.check_all_notifs_sms = true;

					this.checkSetAllCheckboxValue();

	 			}, 1000);
			});

		}else if(this.caller == "Business"){
			this.svc_notifications.getBusinessNotificationSettings().subscribe(data=>{
				this.global_settings = data['business_notif_settings'];
				this.global_attachments = data['business_attachments'];
				this.initializeForm(0);

				var addCtrl = <FormArray> this.frm_notifications.controls.notifications;
				addCtrl.removeAt(0);
				this.global_settings.forEach(item =>{
					let i = 0;
					addCtrl.push(this.setNotification(0,item));
					i=+1;
				})

				var addCtrl = <FormArray> this.frm_notifications.controls.attachments;
				addCtrl.removeAt(0);
				this.global_attachments.forEach(item =>{
					let i = 0;
					addCtrl.push(this.setAttachment(0,item));
					i=+1;
				})
				
				setTimeout(() => { 
					this.loadingIndicator = false;
					this.check_all_docs_email = true;
					this.check_all_docs_sms = true;
					this.check_all_notifs_email = true;
					this.check_all_notifs_sms = true;

					this.checkSetAllCheckboxValue();

	 			}, 1000);
			});

		};

		
	}

	ngAfterViewInit() {
		setTimeout(() => { this.data.changeHelp(helpData["default"])});
	}
	
	public initializeForm(customer_id){

		if(this.caller == "Global" || this.caller == "Business"){
			this.frm_notifications = this.fb.group({
				notifications: this.fb.array([
					this.initNotifications(null),
				]),
				attachments: this.fb.array([
					this.initAttachments(null),
				]),
			});


		}else if(this.caller == "Customer"){
			this.frm_notifications = this.fb.group({
				notifications: this.fb.array([
					this.initNotifications(customer_id),
				]),
				attachments: this.fb.array([
					this.initAttachments(customer_id),
				]),
			});


		};
	}

	public initNotifications(customer_id){
		if(this.caller == "Global" || this.caller == "Business"){
			return this.fb.group({
				id: [''],
				name: [''],
				category_name: [''],
				description:[''],
				notification_id : [''],
				is_email: [0],
				is_sms : [0],
				created_by : [this.user.id],
				email_attachments: [],
			});
		}else if(this.caller == "Customer"){
			return this.fb.group({
				id: [''],
				name: [''],
				category_name: [''],
				description:[''],
				notification_id : [''],
				customer_id: [customer_id],
				is_email: [0],
				is_sms : [0],
				global_email : [0],
				global_sms : [0],
				created_by : [this.user.id],
				email_attachments: [],
			});
		};
		
	}

	public initAttachments(customer_id){
		if(this.caller == "Global" || this.caller == "Business"){
			return this.fb.group({
				id: [''],
				document_name:[''],
				document_type_id : [''],
				is_email: [0],
				is_sms : [0],
				created_by : [this.user.id]
			});
		}else if(this.caller == "Customer"){
			return this.fb.group({
				id: [''],
				document_name:[''],
				customer_id: [customer_id],
				document_type_id : [''],
				is_email: [0],
				is_sms : [0],
				global_email : [0],
				global_sms : [0],
				created_by : [this.user.id]
			});
		};
        
    }

	private setNotification(customer_id, notification) {
		if(this.caller == "Global"){
			return this.fb.group({
				id: [notification.setting_id],
				name: [notification.name],
				category_name: [notification.category_name],
				description: [notification.description],
				notification_id : [notification.id],
				is_email: [notification.is_email],
				is_sms : [notification.is_sms],
				created_by : [this.user.id],
				email_attachments: [notification.attachments]
			});
		}else if(this.caller == "Customer"){
			var email_checker = false;
			var sms_checker = false;
			if (notification.global_email == 0){
				email_checker = true;

				if(this.disable_all_notifs_email == false){
					this.disable_all_notifs_email = true;
				}
			};
			
			if (notification.global_sms == 0){
				sms_checker = true;

				if(this.disable_all_notifs_sms == false){
					this.disable_all_notifs_sms = true;
				}
			};

			return this.fb.group({
				id: [notification.setting_id],
				name: [notification.name],
				category_name: [notification.category_name],
				description: [notification.description],
				customer_id : [this.customer_id],
				notification_id : [notification.id],
				is_email: new FormControl({value: notification.is_email, disabled: email_checker}),
				is_sms : new FormControl({value: notification.is_sms, disabled: sms_checker}),
				created_by : [this.user.id],
				email_attachments: [notification.attachments]
			});

		}else if(this.caller == "Business"){
			var email_checker = false;
			var sms_checker = false;
			if (notification.global_email == 0){
				email_checker = true;

				if(this.disable_all_notifs_email == false){
					this.disable_all_notifs_email = true;
				}
			};
			
			if (notification.global_sms == 0){
				sms_checker = true;

				if(this.disable_all_notifs_sms == false){
					this.disable_all_notifs_sms = true;
				}
			};

			return this.fb.group({
				id: [notification.setting_id],
				name: [notification.name],
				category_name: [notification.category_name],
				description: [notification.description],
				notification_id : [notification.id],
				is_email: new FormControl({value: notification.is_email, disabled: email_checker}),
				is_sms : new FormControl({value: notification.is_sms, disabled: sms_checker}),
				created_by : [this.user.id],
				email_attachments: [notification.attachments]
			});
		}
    }

	private setAttachment(customer_id, attachment) {
		if(this.caller == "Global"){
			return this.fb.group({
				id: [attachment.id],
				document_name:[attachment.document_name],
				document_type_id : [attachment.document_id],
				is_email: [attachment.is_email],
				is_sms : [attachment.is_sms],
				created_by : [this.user.id]
			});
		}else if(this.caller == "Customer"){
			var email_checker = false;
			var sms_checker = false;
			if (attachment.global_email == 0){
				email_checker = true;

				if(this.disable_all_docs_email == false){
					this.disable_all_docs_email = true;
				}
			};
			
			if (attachment.global_sms == 0){
				sms_checker = true;

				if(this.disable_all_docs_sms == false){
					this.disable_all_docs_sms = true;
				}
			};

			return this.fb.group({
				id: [attachment.id],
				document_name:[attachment.document_name],
				customer_id : [this.customer_id],
				document_type_id : [attachment.document_id],
				is_email: new FormControl({value: attachment.is_email, disabled: email_checker}),
				is_sms : new FormControl({value: attachment.is_sms, disabled: sms_checker}),
				created_by : [this.user.id]
			});

		}else if(this.caller == "Business"){
			var email_checker = false;
			var sms_checker = false;
			if (attachment.global_email == 0){
				email_checker = true;

				if(this.disable_all_docs_email == false){
					this.disable_all_docs_email = true;
				}
			};
			
			if (attachment.global_sms == 0){
				sms_checker = true;

				if(this.disable_all_docs_sms == false){
					this.disable_all_docs_sms = true;
				}
			};

			return this.fb.group({
				id: [attachment.id],
				document_name:[attachment.document_name],
				document_type_id : [attachment.document_id],
				is_email: new FormControl({value: attachment.is_email, disabled: email_checker}),
				is_sms : new FormControl({value: attachment.is_sms, disabled: sms_checker}),
				created_by : [this.user.id]
			});
		}
    }

	onNotificationCheckEmailChange(notif, event, caller){
		if (event.target.checked == true) {
			notif.is_email.setValue(1);
		}else{
			if(caller == "notifications"){
				if(this.check_all_notifs_email == true){
					this.check_all_notifs_email = false;
				}
			}else{
				if(this.check_all_docs_email == true){
					this.check_all_docs_email = false;
				}
			}
		};
	}

	onNotificationCheckSMSChange(notif, event, caller){
		if (event.target.checked == true) {
			notif.is_sms.setValue(1);
		}else{
			if(caller == "notifications"){
				if(this.check_all_notifs_sms == true){
					this.check_all_notifs_sms = false;
				}
			}else{
				if(this.check_all_docs_sms == true){
					this.check_all_docs_sms = false;
				}
			}
		}
	}

	checkExistence(notif_attchmt){
		if(notif_attchmt.is_email.value == null && notif_attchmt.is_sms.value == null){
			return true;
		}else{
			return false;
		}
	}
	
	submitForm(notification_settings){
		this.spinner = true;
        this.frm_notifications.disable();
        
        if (this.caller == "Global"){ 
			this.svc_notifications.createNotificationGlobalSettings(notification_settings).subscribe(data=>{
				if(data['error'] == false){
					this.toastr.showSuccess(data['message'], 'Update Global Notification Settings')
				}else{
					this.toastr.showError(data['message'], 'Update Global Notification Settings')
				};

				this.ngOnInit();
			});

			setTimeout(() => {this.spinner = false; this.frm_notifications.enable();}, 1000);
            
		}else if(this.caller == "Customer") {
			this.svc_notifications.createNotificationCustomerSettings(notification_settings).subscribe(data=>{
				if(data['error'] == false){
					this.toastr.showSuccess(data['message'], 'Update Customer Notification Settings')
				}else{
					this.toastr.showError(data['message'], 'Update Customer Notification Settings')
				};

				this.ngOnInit();
			});
			

        }else if(this.caller == "Business") {
			this.svc_notifications.createNotificationBusinessSettings(notification_settings).subscribe(data=>{
				if(data['error'] == false){
					this.toastr.showSuccess(data['message'], 'Update Business Notification Settings')
				}else{
					this.toastr.showError(data['message'], 'Update Business Notification Settings')
				};

				this.ngOnInit();
			});

			setTimeout(() => {this.spinner = false; this.frm_notifications.enable();}, 1000);
		};
	}

	checkAllEmail(settings, chk_is_email, caller){
		if (chk_is_email.target.checked == true){
			settings.map(setting=> { 
				setting.controls.is_email.setValue(true); 
				if(caller=="notifications"){
					this.check_all_notifs_email = true;
				}else{
					this.check_all_docs_email = true;
				};
			})
		}else{
			settings.map(setting=>{ 
				setting.controls.is_email.setValue(false); 
				if(caller=="notifications"){
					this.check_all_notifs_email = false;
				}else{
					this.check_all_docs_email = false;
				};
			})
		}
		this.frm_touched = true;
	}

	checkAllSms(settings, chk_is_sms, caller){
		
		if (chk_is_sms.target.checked == true){
			settings.map(setting=> { 
				setting.controls.is_sms.setValue(true); 
				if(caller=="notifications"){
					this.check_all_notifs_sms = true;
				}else{
					this.check_all_docs_sms = true;
				};	
			})
		}else{
			settings.map(setting=>{ 
				setting.controls.is_sms.setValue(false);
				if(caller=="notifications"){
					this.check_all_notifs_sms = false;
				}else{
					this.check_all_docs_sms = false;
				};	
			})
		}

		this.frm_touched = true;
	}

	checkSetAllCheckboxValue(){
		const notifications = this.frm_notifications.controls.notifications.value;
		const attachments = this.frm_notifications.controls.attachments.value;
		
		notifications.map(notif=>{
			if (notif.is_email == null || notif.is_email == 0) {
				this.check_all_notifs_email = false;
			};

			if (notif.is_sms == null || notif.is_sms == 0) {
				this.check_all_notifs_sms = false;
			} 

		});
	
		attachments.map(doc=>{
			if (doc.is_email == null || doc.is_email == 0) {
				this.check_all_docs_email = false;			
			}; 

			if (doc.is_sms == null || doc.is_sms == 0) {
				this.check_all_docs_sms = false;			
			}; 
		});
	}

	notification_modal: string = '';
	selected_notification: any;	
	public modalRef: NgbModalRef;
	public frm_notif_email_attachments :FormGroup;
	notif_index : number = 0;

	addAttachment(frm_value, notif_index){
		const ctrl_notification = (<any>this.frm_notifications).controls.notifications.controls[notif_index].controls.email_attachments;
		ctrl_notification.setValue(frm_value.attachments);
		
		this.modalRef.close();
		this.frm_touched = true;
	}

	openAttachmentModal(notif, nindex){
		this.notif_index = nindex;

		//initialize email attachment form
		this.frm_notif_email_attachments = this.fb.group ({
			attachments: this.fb.array([this.initNotifEmailAttachment()])
			});
		
			
		this.selected_notification = notif.value;
		this.notification_modal = this.selected_notification['name'];

		//patch value
		var ctr_email_att = <FormArray> this.frm_notif_email_attachments.controls.attachments;
		ctr_email_att.removeAt(0);
		this.selected_notification['email_attachments'].forEach(item =>{
			let i = 0;
			if(this.caller == 'Global' || this.caller == 'Business'){
				ctr_email_att.push(this.setEmailAttachment(0,item));
			}else{
				if(this.caller == 'Customer'){
					ctr_email_att.push(this.setEmailAttachment(this.customer_id,item));
				}
			}
			
			i=+1;
		})
				
		this.modalRef = this.modal.open(this.modalAttachment, { size: 'md', backdrop: 'static' });
	}

	initNotifEmailAttachment(){
		return this.fb.group({
				document_type_id: [''],
				folder: [''],
				label: [''],
				name: [''],
				nar_as_attachment: [0],
				nar_as_link:[''],
				nar_created_by : [this.user.id],
				nar_customer_id : [0],
				nar_document_type_id: [''],
				nar_id: [''],
				nar_notification_id : [''],
				nar_recipient_id: [''],
				notification_id: [''],
				notification_name: ['']
			});
				
				
	}

	setEmailAttachment(customer_id, notif_attachment){
		return this.fb.group({
			document_type_id: [notif_attachment.document_type_id],
			folder: [notif_attachment.folder],
			label: [notif_attachment.label],
			name: [notif_attachment.name],
			nar_as_attachment: [notif_attachment.nar_as_attachment],
			nar_as_link:[notif_attachment.nar_as_link],
			nar_created_by : [this.user.id],
			nar_customer_id : [notif_attachment.nar_customer_id],
			nar_document_type_id: [notif_attachment.nar_document_type_id],
			nar_id: [notif_attachment.nar_id],
			nar_notification_id : [notif_attachment.notification_id],
			nar_recipient_id: [notif_attachment.nar_recipient_id],
			notification_id : [notif_attachment.notification_id],
			notification_name: [notif_attachment.notification_name]});
	}
	

}